import { ReactComponent as PasskeySvg } from './svg/passkey.svg'

const PassKeyIcon = ({ fill = '#A8ADB2', ...props }) => (
  <PasskeySvg fill={fill} {...props} />
)

export default PassKeyIcon
